module.exports = __webpack_public_path__ + "static/media/schedule-pickup-woodridge.2eeb5379.png";